export const MALE_TITAN_TABLE_CONFIG = {
  "sourceWorkbook": "reference-data/aoz/aoz-fleet.xlsx",
  "sourceSheet": "Male Titan Table",
  "extractedAt": "2026-03-11T00:16:43Z",
  "notes": [
    "Tier table extracted from rows 1-34 (Tier 1-3 columns B-AC).",
    "Level table extracted from rows 88-133 (Titan Level progression including tier phase mapping).",
    "Values are parsed directly from sheet cells; blanks omitted."
  ],
  "tierStatsByTierAndLevel": {
    "1": {
      "1": {
        "alloys": 0,
        "titan_attack": 23000,
        "titan_hp": 420000,
        "titan_defense": 2,
        "increase_troops_attack": 0.8,
        "increase_troops_hp_and_defense": 1,
        "destructive_lightning_required_components": 20,
        "destructive_lightning_titan_equipment_chip": 45,
        "destructive_lightning": 141,
        "destructive_lightning_targets": 3
      },
      "2": {
        "alloys": 15,
        "titan_attack": 46000,
        "titan_hp": 840000,
        "titan_defense": 3,
        "increase_troops_attack": 1.6,
        "increase_troops_hp_and_defense": 2,
        "destructive_lightning_required_components": 20,
        "destructive_lightning_titan_equipment_chip": 15,
        "destructive_lightning": 159,
        "destructive_lightning_targets": 3
      },
      "3": {
        "alloys": 23,
        "titan_attack": 69000,
        "titan_hp": 1260000,
        "titan_defense": 5,
        "increase_troops_attack": 2.4,
        "increase_troops_hp_and_defense": 3,
        "destructive_lightning_required_components": 24,
        "destructive_lightning_titan_equipment_chip": 20,
        "destructive_lightning": 180,
        "destructive_lightning_targets": 3
      },
      "4": {
        "alloys": 32,
        "titan_attack": 92000,
        "titan_hp": 1680000,
        "titan_defense": 6,
        "increase_troops_attack": 3.2,
        "increase_troops_hp_and_defense": 4,
        "destructive_lightning_required_components": 28,
        "destructive_lightning_titan_equipment_chip": 25,
        "destructive_lightning": 201,
        "destructive_lightning_targets": 3
      },
      "5": {
        "alloys": 41,
        "titan_attack": 115000,
        "titan_hp": 2100000,
        "titan_defense": 8,
        "increase_troops_attack": 4,
        "increase_troops_hp_and_defense": 5,
        "destructive_lightning_required_components": 32,
        "destructive_lightning_titan_equipment_chip": 33,
        "destructive_lightning": 219,
        "destructive_lightning_targets": 3
      },
      "6": {
        "alloys": 57,
        "titan_attack": 138000,
        "titan_hp": 2520000,
        "titan_defense": 9,
        "increase_troops_attack": 4.8,
        "increase_troops_hp_and_defense": 6,
        "destructive_lightning_required_components": 36,
        "destructive_lightning_titan_equipment_chip": 41,
        "destructive_lightning": 240,
        "destructive_lightning_targets": 3
      },
      "7": {
        "alloys": 75,
        "titan_attack": 161000,
        "titan_hp": 2940000,
        "titan_defense": 11,
        "increase_troops_attack": 5.6,
        "increase_troops_hp_and_defense": 7,
        "destructive_lightning_required_components": 40,
        "destructive_lightning_titan_equipment_chip": 50,
        "destructive_lightning": 261,
        "destructive_lightning_targets": 3
      },
      "8": {
        "alloys": 89,
        "titan_attack": 184000,
        "titan_hp": 3360000,
        "titan_defense": 12,
        "increase_troops_attack": 6.4,
        "increase_troops_hp_and_defense": 8,
        "destructive_lightning_required_components": 44,
        "destructive_lightning_titan_equipment_chip": 58,
        "destructive_lightning": 279,
        "destructive_lightning_targets": 3
      },
      "9": {
        "alloys": 104,
        "titan_attack": 207000,
        "titan_hp": 3780000,
        "titan_defense": 14,
        "increase_troops_attack": 7.2,
        "increase_troops_hp_and_defense": 9,
        "destructive_lightning_required_components": 48,
        "destructive_lightning_titan_equipment_chip": 65,
        "destructive_lightning": 300,
        "destructive_lightning_targets": 3
      },
      "10": {
        "alloys": 118,
        "titan_attack": 230000,
        "titan_hp": 4200000,
        "titan_defense": 15,
        "increase_troops_attack": 8,
        "increase_troops_hp_and_defense": 10,
        "destructive_lightning_required_components": 52,
        "destructive_lightning_titan_equipment_chip": 71,
        "destructive_lightning": 316,
        "destructive_lightning_targets": 4
      },
      "11": {
        "alloys": 135,
        "titan_attack": 253000,
        "titan_hp": 4620000,
        "titan_defense": 17,
        "increase_troops_attack": 8.8,
        "increase_troops_hp_and_defense": 11,
        "destructive_lightning_required_components": 56,
        "destructive_lightning_titan_equipment_chip": 78,
        "destructive_lightning": 332,
        "destructive_lightning_targets": 4
      },
      "12": {
        "alloys": 154,
        "titan_attack": 276000,
        "titan_hp": 5040000,
        "titan_defense": 18,
        "increase_troops_attack": 9.6,
        "increase_troops_hp_and_defense": 12,
        "destructive_lightning_required_components": 60,
        "destructive_lightning_titan_equipment_chip": 87,
        "destructive_lightning": 344,
        "destructive_lightning_targets": 4
      },
      "13": {
        "alloys": 171,
        "titan_attack": 299000,
        "titan_hp": 5460000,
        "titan_defense": 20,
        "increase_troops_attack": 10.4,
        "increase_troops_hp_and_defense": 13,
        "destructive_lightning_required_components": 64,
        "destructive_lightning_titan_equipment_chip": 98,
        "destructive_lightning": 360,
        "destructive_lightning_targets": 4
      },
      "14": {
        "alloys": 188,
        "titan_attack": 322000,
        "titan_hp": 5880000,
        "titan_defense": 21,
        "increase_troops_attack": 11.2,
        "increase_troops_hp_and_defense": 14,
        "destructive_lightning_required_components": 68,
        "destructive_lightning_titan_equipment_chip": 110,
        "destructive_lightning": 376,
        "destructive_lightning_targets": 4
      },
      "15": {
        "alloys": 203,
        "titan_attack": 345000,
        "titan_hp": 6300000,
        "titan_defense": 23,
        "increase_troops_attack": 12,
        "increase_troops_hp_and_defense": 15,
        "destructive_lightning_required_components": 72,
        "destructive_lightning_titan_equipment_chip": 132,
        "destructive_lightning": 392,
        "destructive_lightning_targets": 4
      },
      "16": {
        "alloys": 219,
        "titan_attack": 368000,
        "titan_hp": 6720000,
        "titan_defense": 24,
        "increase_troops_attack": 12.8,
        "increase_troops_hp_and_defense": 16,
        "destructive_lightning_required_components": 76,
        "destructive_lightning_titan_equipment_chip": 145,
        "destructive_lightning": 404,
        "destructive_lightning_targets": 4
      },
      "17": {
        "alloys": 236,
        "titan_attack": 391000,
        "titan_hp": 7140000,
        "titan_defense": 26,
        "increase_troops_attack": 13.6,
        "increase_troops_hp_and_defense": 17,
        "destructive_lightning_required_components": 80,
        "destructive_lightning_titan_equipment_chip": 154,
        "destructive_lightning": 420,
        "destructive_lightning_targets": 4
      },
      "18": {
        "alloys": 255,
        "titan_attack": 414000,
        "titan_hp": 7560000,
        "titan_defense": 27,
        "increase_troops_attack": 14.4,
        "increase_troops_hp_and_defense": 18,
        "destructive_lightning_required_components": 84,
        "destructive_lightning_titan_equipment_chip": 163,
        "destructive_lightning": 436,
        "destructive_lightning_targets": 4
      },
      "19": {
        "alloys": 276,
        "titan_attack": 437000,
        "titan_hp": 7980000,
        "titan_defense": 29,
        "increase_troops_attack": 15.2,
        "increase_troops_hp_and_defense": 19,
        "destructive_lightning_required_components": 88,
        "destructive_lightning_titan_equipment_chip": 172,
        "destructive_lightning": 450,
        "destructive_lightning_targets": 5
      },
      "20": {
        "alloys": 298,
        "titan_attack": 460000,
        "titan_hp": 8400000,
        "titan_defense": 30,
        "increase_troops_attack": 16,
        "increase_troops_hp_and_defense": 20,
        "destructive_lightning_required_components": 92,
        "destructive_lightning_titan_equipment_chip": 183,
        "destructive_lightning": 460,
        "destructive_lightning_targets": 5
      },
      "21": {
        "alloys": 322,
        "titan_attack": 483000,
        "titan_hp": 8820000,
        "titan_defense": 32,
        "increase_troops_attack": 16.8,
        "increase_troops_hp_and_defense": 21,
        "destructive_lightning_required_components": 96,
        "destructive_lightning_titan_equipment_chip": 202,
        "destructive_lightning": 470,
        "destructive_lightning_targets": 5
      },
      "22": {
        "alloys": 354,
        "titan_attack": 506000,
        "titan_hp": 9240000,
        "titan_defense": 33,
        "increase_troops_attack": 17.6,
        "increase_troops_hp_and_defense": 22,
        "destructive_lightning_required_components": 100,
        "destructive_lightning_titan_equipment_chip": 222,
        "destructive_lightning": 480,
        "destructive_lightning_targets": 5
      },
      "23": {
        "alloys": 389,
        "titan_attack": 529000,
        "titan_hp": 9660000,
        "titan_defense": 35,
        "increase_troops_attack": 18.4,
        "increase_troops_hp_and_defense": 23,
        "destructive_lightning_required_components": 104,
        "destructive_lightning_titan_equipment_chip": 244,
        "destructive_lightning": 490,
        "destructive_lightning_targets": 5
      },
      "24": {
        "alloys": 428,
        "titan_attack": 552000,
        "titan_hp": 10080000,
        "titan_defense": 36,
        "increase_troops_attack": 19.2,
        "increase_troops_hp_and_defense": 24,
        "destructive_lightning_required_components": 108,
        "destructive_lightning_titan_equipment_chip": 268,
        "destructive_lightning": 500,
        "destructive_lightning_targets": 5
      },
      "25": {
        "alloys": 479,
        "titan_attack": 575000,
        "titan_hp": 10500000,
        "titan_defense": 38,
        "increase_troops_attack": 20,
        "increase_troops_hp_and_defense": 25,
        "destructive_lightning_required_components": 112,
        "destructive_lightning_titan_equipment_chip": 295,
        "destructive_lightning": 510,
        "destructive_lightning_targets": 5
      },
      "26": {
        "alloys": 537,
        "titan_attack": 598000,
        "titan_hp": 10920000,
        "titan_defense": 39,
        "increase_troops_attack": 20.8,
        "increase_troops_hp_and_defense": 26,
        "destructive_lightning_required_components": 116,
        "destructive_lightning_titan_equipment_chip": 325,
        "destructive_lightning": 520,
        "destructive_lightning_targets": 5
      },
      "27": {
        "alloys": 601,
        "titan_attack": 621000,
        "titan_hp": 11340000,
        "titan_defense": 41,
        "increase_troops_attack": 21.6,
        "increase_troops_hp_and_defense": 27
      },
      "28": {
        "alloys": 674,
        "titan_attack": 644000,
        "titan_hp": 11760000,
        "titan_defense": 42,
        "increase_troops_attack": 22.4,
        "increase_troops_hp_and_defense": 28
      },
      "29": {
        "alloys": 754,
        "titan_attack": 667000,
        "titan_hp": 12180000,
        "titan_defense": 44,
        "increase_troops_attack": 23.2,
        "increase_troops_hp_and_defense": 29
      },
      "30": {
        "alloys": 845,
        "titan_attack": 690000,
        "titan_hp": 12600000,
        "titan_defense": 45,
        "increase_troops_attack": 24,
        "increase_troops_hp_and_defense": 30
      }
    },
    "2": {
      "1": {
        "alloys": 0,
        "titan_attack": 23000,
        "titan_hp": 420000,
        "titan_defense": 2,
        "enemy_mid_range_attack_reduction": 1.8,
        "enemy_long_range_attack_reduction": 1.8,
        "thor": 4,
        "thor_total_attack_kill_bonus": 0.8,
        "thor_required_components": 40,
        "thor_titan_equipment_chip": 90
      },
      "2": {
        "alloys": 23,
        "titan_attack": 46000,
        "titan_hp": 840000,
        "titan_defense": 3,
        "enemy_mid_range_attack_reduction": 3.6,
        "enemy_long_range_attack_reduction": 3.6,
        "thor": 4.8,
        "thor_total_attack_kill_bonus": 1,
        "thor_required_components": 40,
        "thor_titan_equipment_chip": 23
      },
      "3": {
        "alloys": 34,
        "titan_attack": 69000,
        "titan_hp": 1260000,
        "titan_defense": 5,
        "enemy_mid_range_attack_reduction": 5.4,
        "enemy_long_range_attack_reduction": 5.4,
        "thor": 5.6,
        "thor_total_attack_kill_bonus": 1.1,
        "thor_required_components": 40,
        "thor_titan_equipment_chip": 29
      },
      "4": {
        "alloys": 47,
        "titan_attack": 92000,
        "titan_hp": 1680000,
        "titan_defense": 6,
        "enemy_mid_range_attack_reduction": 7.2,
        "enemy_long_range_attack_reduction": 7.2,
        "thor": 6.4,
        "thor_total_attack_kill_bonus": 1.3,
        "thor_required_components": 40,
        "thor_titan_equipment_chip": 38
      },
      "5": {
        "alloys": 61,
        "titan_attack": 115000,
        "titan_hp": 2100000,
        "titan_defense": 8,
        "enemy_mid_range_attack_reduction": 9,
        "enemy_long_range_attack_reduction": 9,
        "thor": 7.2,
        "thor_total_attack_kill_bonus": 1.4,
        "thor_required_components": 40,
        "thor_titan_equipment_chip": 49
      },
      "6": {
        "alloys": 86,
        "titan_attack": 138000,
        "titan_hp": 2520000,
        "titan_defense": 9,
        "enemy_mid_range_attack_reduction": 10.8,
        "enemy_long_range_attack_reduction": 10.8,
        "thor": 8,
        "thor_total_attack_kill_bonus": 1.6,
        "thor_required_components": 40,
        "thor_titan_equipment_chip": 61
      },
      "7": {
        "alloys": 112,
        "titan_attack": 161000,
        "titan_hp": 2940000,
        "titan_defense": 11,
        "enemy_mid_range_attack_reduction": 12.6,
        "enemy_long_range_attack_reduction": 12.6,
        "thor": 8.8,
        "thor_total_attack_kill_bonus": 1.8,
        "thor_required_components": 40,
        "thor_titan_equipment_chip": 75
      },
      "8": {
        "alloys": 134,
        "titan_attack": 184000,
        "titan_hp": 3360000,
        "titan_defense": 12,
        "enemy_mid_range_attack_reduction": 14.4,
        "enemy_long_range_attack_reduction": 14.4,
        "thor": 9.6,
        "thor_total_attack_kill_bonus": 1.9,
        "thor_required_components": 44,
        "thor_titan_equipment_chip": 86
      },
      "9": {
        "alloys": 156,
        "titan_attack": 207000,
        "titan_hp": 3780000,
        "titan_defense": 14,
        "enemy_mid_range_attack_reduction": 16.2,
        "enemy_long_range_attack_reduction": 16.2,
        "thor": 10.4,
        "thor_total_attack_kill_bonus": 2.1,
        "thor_required_components": 48,
        "thor_titan_equipment_chip": 97
      },
      "10": {
        "alloys": 177,
        "titan_attack": 230000,
        "titan_hp": 4200000,
        "titan_defense": 15,
        "enemy_mid_range_attack_reduction": 18,
        "enemy_long_range_attack_reduction": 18,
        "thor": 11.2,
        "thor_total_attack_kill_bonus": 2.2,
        "thor_required_components": 52,
        "thor_titan_equipment_chip": 106
      },
      "11": {
        "alloys": 202,
        "titan_attack": 253000,
        "titan_hp": 4620000,
        "titan_defense": 17,
        "enemy_mid_range_attack_reduction": 19.8,
        "enemy_long_range_attack_reduction": 19.8,
        "thor": 12,
        "thor_total_attack_kill_bonus": 2.4,
        "thor_required_components": 56,
        "thor_titan_equipment_chip": 112
      },
      "12": {
        "alloys": 231,
        "titan_attack": 276000,
        "titan_hp": 5040000,
        "titan_defense": 18,
        "enemy_mid_range_attack_reduction": 21.6,
        "enemy_long_range_attack_reduction": 21.6,
        "thor": 12.8,
        "thor_total_attack_kill_bonus": 2.6,
        "thor_required_components": 60,
        "thor_titan_equipment_chip": 119
      },
      "13": {
        "alloys": 256,
        "titan_attack": 299000,
        "titan_hp": 5460000,
        "titan_defense": 20,
        "enemy_mid_range_attack_reduction": 23.4,
        "enemy_long_range_attack_reduction": 23.4,
        "thor": 13.6,
        "thor_total_attack_kill_bonus": 2.7,
        "thor_required_components": 64,
        "thor_titan_equipment_chip": 126
      },
      "14": {
        "alloys": 282,
        "titan_attack": 322000,
        "titan_hp": 5880000,
        "titan_defense": 21,
        "enemy_mid_range_attack_reduction": 25.2,
        "enemy_long_range_attack_reduction": 25.2,
        "thor": 14.4,
        "thor_total_attack_kill_bonus": 2.9,
        "thor_required_components": 68,
        "thor_titan_equipment_chip": 133
      },
      "15": {
        "alloys": 304,
        "titan_attack": 345000,
        "titan_hp": 6300000,
        "titan_defense": 23,
        "enemy_mid_range_attack_reduction": 27,
        "enemy_long_range_attack_reduction": 27,
        "thor": 15.2,
        "thor_total_attack_kill_bonus": 3,
        "thor_required_components": 72,
        "thor_titan_equipment_chip": 141
      },
      "16": {
        "alloys": 322,
        "titan_attack": 368000,
        "titan_hp": 6720000,
        "titan_defense": 24,
        "enemy_mid_range_attack_reduction": 28.8,
        "enemy_long_range_attack_reduction": 28.8,
        "thor": 16,
        "thor_total_attack_kill_bonus": 3.2,
        "thor_required_components": 76,
        "thor_titan_equipment_chip": 150
      },
      "17": {
        "alloys": 342,
        "titan_attack": 391000,
        "titan_hp": 7140000,
        "titan_defense": 26,
        "enemy_mid_range_attack_reduction": 30.6,
        "enemy_long_range_attack_reduction": 30.6,
        "thor": 16.8,
        "thor_total_attack_kill_bonus": 3.4,
        "thor_required_components": 80,
        "thor_titan_equipment_chip": 159
      },
      "18": {
        "alloys": 362,
        "titan_attack": 414000,
        "titan_hp": 7560000,
        "titan_defense": 27,
        "enemy_mid_range_attack_reduction": 32.4,
        "enemy_long_range_attack_reduction": 32.4,
        "thor": 17.6,
        "thor_total_attack_kill_bonus": 3.5,
        "thor_required_components": 84,
        "thor_titan_equipment_chip": 168
      },
      "19": {
        "alloys": 384,
        "titan_attack": 437000,
        "titan_hp": 7980000,
        "titan_defense": 29,
        "enemy_mid_range_attack_reduction": 34.2,
        "enemy_long_range_attack_reduction": 34.2,
        "thor": 18.4,
        "thor_total_attack_kill_bonus": 3.7,
        "thor_required_components": 88,
        "thor_titan_equipment_chip": 178
      },
      "20": {
        "alloys": 407,
        "titan_attack": 460000,
        "titan_hp": 8400000,
        "titan_defense": 30,
        "enemy_mid_range_attack_reduction": 36,
        "enemy_long_range_attack_reduction": 36,
        "thor": 19.2,
        "thor_total_attack_kill_bonus": 3.8,
        "thor_required_components": 92,
        "thor_titan_equipment_chip": 189
      },
      "21": {
        "alloys": 431,
        "titan_attack": 483000,
        "titan_hp": 8820000,
        "titan_defense": 32,
        "enemy_mid_range_attack_reduction": 37.8,
        "enemy_long_range_attack_reduction": 37.8,
        "thor": 20,
        "thor_total_attack_kill_bonus": 4,
        "thor_required_components": 96,
        "thor_titan_equipment_chip": 204
      },
      "22": {
        "alloys": 457,
        "titan_attack": 506000,
        "titan_hp": 9240000,
        "titan_defense": 33,
        "enemy_mid_range_attack_reduction": 39.6,
        "enemy_long_range_attack_reduction": 39.6,
        "thor": 20.8,
        "thor_total_attack_kill_bonus": 4.2,
        "thor_required_components": 100,
        "thor_titan_equipment_chip": 220
      },
      "23": {
        "alloys": 485,
        "titan_attack": 529000,
        "titan_hp": 9660000,
        "titan_defense": 35,
        "enemy_mid_range_attack_reduction": 41.4,
        "enemy_long_range_attack_reduction": 41.4,
        "thor": 21.6,
        "thor_total_attack_kill_bonus": 4.3,
        "thor_required_components": 104,
        "thor_titan_equipment_chip": 238
      },
      "24": {
        "alloys": 514,
        "titan_attack": 552000,
        "titan_hp": 10080000,
        "titan_defense": 36,
        "enemy_mid_range_attack_reduction": 43.2,
        "enemy_long_range_attack_reduction": 43.2,
        "thor": 22.4,
        "thor_total_attack_kill_bonus": 4.5,
        "thor_required_components": 108,
        "thor_titan_equipment_chip": 257
      },
      "25": {
        "alloys": 544,
        "titan_attack": 575000,
        "titan_hp": 10500000,
        "titan_defense": 38,
        "enemy_mid_range_attack_reduction": 45,
        "enemy_long_range_attack_reduction": 45,
        "thor": 23.2,
        "thor_total_attack_kill_bonus": 4.6,
        "thor_required_components": 112,
        "thor_titan_equipment_chip": 278
      },
      "26": {
        "alloys": 599,
        "titan_attack": 598000,
        "titan_hp": 10920000,
        "titan_defense": 39,
        "enemy_mid_range_attack_reduction": 46.8,
        "enemy_long_range_attack_reduction": 46.8,
        "thor": 24,
        "thor_total_attack_kill_bonus": 4.8,
        "thor_required_components": 116,
        "thor_titan_equipment_chip": 300
      },
      "27": {
        "alloys": 659,
        "titan_attack": 621000,
        "titan_hp": 11340000,
        "titan_defense": 41,
        "enemy_mid_range_attack_reduction": 48.6,
        "enemy_long_range_attack_reduction": 48.6
      },
      "28": {
        "alloys": 725,
        "titan_attack": 644000,
        "titan_hp": 11760000,
        "titan_defense": 42,
        "enemy_mid_range_attack_reduction": 50.4,
        "enemy_long_range_attack_reduction": 50.4
      },
      "29": {
        "alloys": 797,
        "titan_attack": 667000,
        "titan_hp": 12180000,
        "titan_defense": 44,
        "enemy_mid_range_attack_reduction": 52.2,
        "enemy_long_range_attack_reduction": 52.2
      },
      "30": {
        "alloys": 877,
        "titan_attack": 690000,
        "titan_hp": 12600000,
        "titan_defense": 45,
        "enemy_mid_range_attack_reduction": 54,
        "enemy_long_range_attack_reduction": 54
      }
    },
    "3": {
      "1": {
        "alloys": 0,
        "increase_titan_damage_against_mr_troops": 0.8,
        "increase_bonus_effect_of_energy_guard": 1.3,
        "increase_damage_to_mid_range_troops": 0.5,
        "increase_hp_and_defense_of_meele_troops": 1.8,
        "weaken_energy": 4,
        "required_components": 60,
        "titan_equipment_chip": 180
      },
      "2": {
        "alloys": 30,
        "increase_titan_damage_against_mr_troops": 1.6,
        "increase_bonus_effect_of_energy_guard": 2.6,
        "increase_damage_to_mid_range_troops": 1,
        "increase_hp_and_defense_of_meele_troops": 3.6,
        "weaken_energy": 4.8,
        "required_components": 60,
        "titan_equipment_chip": 34
      },
      "3": {
        "alloys": 45,
        "increase_titan_damage_against_mr_troops": 2.4,
        "increase_bonus_effect_of_energy_guard": 3.9,
        "increase_damage_to_mid_range_troops": 1.5,
        "increase_hp_and_defense_of_meele_troops": 5.4,
        "weaken_energy": 5.6,
        "required_components": 60,
        "titan_equipment_chip": 44
      },
      "4": {
        "alloys": 63,
        "increase_titan_damage_against_mr_troops": 3.2,
        "increase_bonus_effect_of_energy_guard": 5.2,
        "increase_damage_to_mid_range_troops": 2,
        "increase_hp_and_defense_of_meele_troops": 7.2,
        "weaken_energy": 6.4,
        "required_components": 60,
        "titan_equipment_chip": 57
      },
      "5": {
        "alloys": 82,
        "increase_titan_damage_against_mr_troops": 4,
        "increase_bonus_effect_of_energy_guard": 6.5,
        "increase_damage_to_mid_range_troops": 2.5,
        "increase_hp_and_defense_of_meele_troops": 9,
        "weaken_energy": 7.2,
        "required_components": 60,
        "titan_equipment_chip": 73
      },
      "6": {
        "alloys": 115,
        "increase_titan_damage_against_mr_troops": 4.8,
        "increase_bonus_effect_of_energy_guard": 7.8,
        "increase_damage_to_mid_range_troops": 3,
        "increase_hp_and_defense_of_meele_troops": 10.8,
        "weaken_energy": 8,
        "required_components": 60,
        "titan_equipment_chip": 92
      },
      "7": {
        "alloys": 149,
        "increase_titan_damage_against_mr_troops": 5.6,
        "increase_bonus_effect_of_energy_guard": 9.1,
        "increase_damage_to_mid_range_troops": 3.5,
        "increase_hp_and_defense_of_meele_troops": 12.6,
        "weaken_energy": 8.8,
        "required_components": 60,
        "titan_equipment_chip": 112
      },
      "8": {
        "alloys": 179,
        "increase_titan_damage_against_mr_troops": 6.4,
        "increase_bonus_effect_of_energy_guard": 10.4,
        "increase_damage_to_mid_range_troops": 4,
        "increase_hp_and_defense_of_meele_troops": 14.4,
        "weaken_energy": 9.6,
        "required_components": 60,
        "titan_equipment_chip": 130
      },
      "9": {
        "alloys": 207,
        "increase_titan_damage_against_mr_troops": 7.2,
        "increase_bonus_effect_of_energy_guard": 11.7,
        "increase_damage_to_mid_range_troops": 4.5,
        "increase_hp_and_defense_of_meele_troops": 16.2,
        "weaken_energy": 10.4,
        "required_components": 60,
        "titan_equipment_chip": 145
      },
      "10": {
        "alloys": 237,
        "increase_titan_damage_against_mr_troops": 8,
        "increase_bonus_effect_of_energy_guard": 13,
        "increase_damage_to_mid_range_troops": 5,
        "increase_hp_and_defense_of_meele_troops": 18,
        "weaken_energy": 11.2,
        "required_components": 60,
        "titan_equipment_chip": 158
      },
      "11": {
        "alloys": 270,
        "increase_titan_damage_against_mr_troops": 8.8,
        "increase_bonus_effect_of_energy_guard": 14.3,
        "increase_damage_to_mid_range_troops": 5.5,
        "increase_hp_and_defense_of_meele_troops": 19.8,
        "weaken_energy": 12,
        "required_components": 60,
        "titan_equipment_chip": 168
      },
      "12": {
        "alloys": 307,
        "increase_titan_damage_against_mr_troops": 9.6,
        "increase_bonus_effect_of_energy_guard": 15.6,
        "increase_damage_to_mid_range_troops": 6,
        "increase_hp_and_defense_of_meele_troops": 21.6,
        "weaken_energy": 12.8,
        "required_components": 60,
        "titan_equipment_chip": 178
      },
      "13": {
        "alloys": 341,
        "increase_titan_damage_against_mr_troops": 10.4,
        "increase_bonus_effect_of_energy_guard": 16.9,
        "increase_damage_to_mid_range_troops": 6.5,
        "increase_hp_and_defense_of_meele_troops": 23.4,
        "weaken_energy": 13.6,
        "required_components": 64,
        "titan_equipment_chip": 189
      },
      "14": {
        "alloys": 375,
        "increase_titan_damage_against_mr_troops": 11.2,
        "increase_bonus_effect_of_energy_guard": 18.2,
        "increase_damage_to_mid_range_troops": 7,
        "increase_hp_and_defense_of_meele_troops": 25.2,
        "weaken_energy": 14.4,
        "required_components": 68,
        "titan_equipment_chip": 200
      },
      "15": {
        "alloys": 405,
        "increase_titan_damage_against_mr_troops": 12,
        "increase_bonus_effect_of_energy_guard": 19.5,
        "increase_damage_to_mid_range_troops": 7.5,
        "increase_hp_and_defense_of_meele_troops": 27,
        "weaken_energy": 15.2,
        "required_components": 72,
        "titan_equipment_chip": 212
      },
      "16": {
        "alloys": 430,
        "increase_titan_damage_against_mr_troops": 12.8,
        "increase_bonus_effect_of_energy_guard": 20.8,
        "increase_damage_to_mid_range_troops": 8,
        "increase_hp_and_defense_of_meele_troops": 28.8,
        "weaken_energy": 16,
        "required_components": 76,
        "titan_equipment_chip": 225
      },
      "17": {
        "alloys": 455,
        "increase_titan_damage_against_mr_troops": 13.6,
        "increase_bonus_effect_of_energy_guard": 22.1,
        "increase_damage_to_mid_range_troops": 8.5,
        "increase_hp_and_defense_of_meele_troops": 30.6,
        "weaken_energy": 16.8,
        "required_components": 80,
        "titan_equipment_chip": 238
      },
      "18": {
        "alloys": 483,
        "increase_titan_damage_against_mr_troops": 14.4,
        "increase_bonus_effect_of_energy_guard": 23.4,
        "increase_damage_to_mid_range_troops": 9,
        "increase_hp_and_defense_of_meele_troops": 32.4,
        "weaken_energy": 17.6,
        "required_components": 84,
        "titan_equipment_chip": 252
      },
      "19": {
        "alloys": 512,
        "increase_titan_damage_against_mr_troops": 15.2,
        "increase_bonus_effect_of_energy_guard": 24.7,
        "increase_damage_to_mid_range_troops": 9.5,
        "increase_hp_and_defense_of_meele_troops": 34.2,
        "weaken_energy": 18.4,
        "required_components": 88,
        "titan_equipment_chip": 267
      },
      "20": {
        "alloys": 542,
        "increase_titan_damage_against_mr_troops": 16,
        "increase_bonus_effect_of_energy_guard": 26,
        "increase_damage_to_mid_range_troops": 10,
        "increase_hp_and_defense_of_meele_troops": 36,
        "weaken_energy": 19.2,
        "required_components": 92,
        "titan_equipment_chip": 283
      },
      "21": {
        "alloys": 575,
        "increase_titan_damage_against_mr_troops": 16.8,
        "increase_bonus_effect_of_energy_guard": 27.3,
        "increase_damage_to_mid_range_troops": 10.5,
        "increase_hp_and_defense_of_meele_troops": 37.8,
        "weaken_energy": 20,
        "required_components": 96,
        "titan_equipment_chip": 306
      },
      "22": {
        "alloys": 610,
        "increase_titan_damage_against_mr_troops": 17.6,
        "increase_bonus_effect_of_energy_guard": 28.6,
        "increase_damage_to_mid_range_troops": 11,
        "increase_hp_and_defense_of_meele_troops": 39.6,
        "weaken_energy": 20.8,
        "required_components": 100,
        "titan_equipment_chip": 331
      },
      "23": {
        "alloys": 646,
        "increase_titan_damage_against_mr_troops": 18.4,
        "increase_bonus_effect_of_energy_guard": 29.9,
        "increase_damage_to_mid_range_troops": 11.5,
        "increase_hp_and_defense_of_meele_troops": 41.4,
        "weaken_energy": 21.6,
        "required_components": 104,
        "titan_equipment_chip": 357
      },
      "24": {
        "alloys": 685,
        "increase_titan_damage_against_mr_troops": 19.2,
        "increase_bonus_effect_of_energy_guard": 31.2,
        "increase_damage_to_mid_range_troops": 12,
        "increase_hp_and_defense_of_meele_troops": 43.2,
        "weaken_energy": 22.4,
        "required_components": 108,
        "titan_equipment_chip": 386
      },
      "25": {
        "alloys": 726,
        "increase_titan_damage_against_mr_troops": 20,
        "increase_bonus_effect_of_energy_guard": 32.5,
        "increase_damage_to_mid_range_troops": 12.5,
        "increase_hp_and_defense_of_meele_troops": 45,
        "weaken_energy": 23.2,
        "required_components": 112,
        "titan_equipment_chip": 416
      },
      "26": {
        "alloys": 799,
        "increase_titan_damage_against_mr_troops": 20.8,
        "increase_bonus_effect_of_energy_guard": 33.8,
        "increase_damage_to_mid_range_troops": 13,
        "increase_hp_and_defense_of_meele_troops": 46.8,
        "weaken_energy": 24,
        "required_components": 116,
        "titan_equipment_chip": 450
      },
      "27": {
        "alloys": 878,
        "increase_titan_damage_against_mr_troops": 21.6,
        "increase_bonus_effect_of_energy_guard": 35.1,
        "increase_damage_to_mid_range_troops": 13.5,
        "increase_hp_and_defense_of_meele_troops": 48.6
      },
      "28": {
        "alloys": 966,
        "increase_titan_damage_against_mr_troops": 22.4,
        "increase_bonus_effect_of_energy_guard": 36.4,
        "increase_damage_to_mid_range_troops": 14,
        "increase_hp_and_defense_of_meele_troops": 50.4
      },
      "29": {
        "alloys": 1063,
        "increase_titan_damage_against_mr_troops": 23.2,
        "increase_bonus_effect_of_energy_guard": 37.7,
        "increase_damage_to_mid_range_troops": 14.5,
        "increase_hp_and_defense_of_meele_troops": 52.2
      },
      "30": {
        "alloys": 1169,
        "increase_titan_damage_against_mr_troops": 24,
        "increase_bonus_effect_of_energy_guard": 39,
        "increase_damage_to_mid_range_troops": 15,
        "increase_hp_and_defense_of_meele_troops": 54
      }
    }
  },
  "levelProgression": [
    {
      "titanLevel": 1,
      "xp": 0,
      "xpCumulative": 0,
      "attack": 292000,
      "hp": 2256800,
      "defense": 23,
      "maxLevel": 5,
      "attackCumulative": 292000,
      "hpCumulative": 2256800,
      "defenseCumulative": 23,
      "tierPhase": "Green",
      "tierLevel": 0,
      "phaseAndLevel": "Green0",
      "phaseAttack": 0,
      "phaseHp": 0,
      "phaseDefense": 0,
      "phaseAttackCumulative": 0,
      "phaseHpCumulative": 0,
      "phaseDefenseCumulative": 0
    },
    {
      "titanLevel": 2,
      "xp": 500,
      "xpCumulative": 500,
      "attack": 31510,
      "hp": 336595,
      "defense": 2,
      "maxLevel": 5,
      "attackCumulative": 323510,
      "hpCumulative": 2593395,
      "defenseCumulative": 25,
      "tierPhase": "Green",
      "tierLevel": 1,
      "phaseAndLevel": "Green1",
      "phaseAttack": 27359,
      "phaseHp": 402854,
      "phaseDefense": 2,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2
    },
    {
      "titanLevel": 3,
      "xp": 1200,
      "xpCumulative": 1700,
      "attack": 34911,
      "hp": 386797,
      "defense": 3,
      "maxLevel": 5,
      "attackCumulative": 358421,
      "hpCumulative": 2980192,
      "defenseCumulative": 28,
      "tierPhase": "Green",
      "tierLevel": 2,
      "phaseAndLevel": "Green2",
      "phaseAttack": 27359,
      "phaseHp": 402854,
      "phaseDefense": 2,
      "phaseAttackCumulative": 54718,
      "phaseHpCumulative": 805708,
      "phaseDefenseCumulative": 4
    },
    {
      "titanLevel": 4,
      "xp": 2200,
      "xpCumulative": 3900,
      "attack": 38678,
      "hp": 444487,
      "defense": 3,
      "maxLevel": 5,
      "attackCumulative": 397099,
      "hpCumulative": 3424679,
      "defenseCumulative": 31,
      "tierPhase": "Green",
      "tierLevel": 3,
      "phaseAndLevel": "Green3",
      "phaseAttack": 27359,
      "phaseHp": 402854,
      "phaseDefense": 2,
      "phaseAttackCumulative": 82077,
      "phaseHpCumulative": 1208562,
      "phaseDefenseCumulative": 6
    },
    {
      "titanLevel": 5,
      "xp": 3700,
      "xpCumulative": 7600,
      "attack": 42852,
      "hp": 510781,
      "defense": 3,
      "maxLevel": 5,
      "attackCumulative": 439951,
      "hpCumulative": 3935460,
      "defenseCumulative": 34,
      "tierPhase": "Green",
      "tierLevel": 4,
      "phaseAndLevel": "Green4",
      "phaseAttack": 27359,
      "phaseHp": 402854,
      "phaseDefense": 2,
      "phaseAttackCumulative": 109436,
      "phaseHpCumulative": 1611416,
      "phaseDefenseCumulative": 8
    },
    {
      "titanLevel": 6,
      "xp": 5800,
      "xpCumulative": 13400,
      "attack": 44031,
      "hp": 506294,
      "defense": 3,
      "maxLevel": 5,
      "attackCumulative": 483982,
      "hpCumulative": 4441754,
      "defenseCumulative": 37,
      "tierPhase": "Green",
      "tierLevel": 5,
      "phaseAndLevel": "Green5",
      "phaseAttack": 27359,
      "phaseHp": 402854,
      "phaseDefense": 2,
      "phaseAttackCumulative": 136795,
      "phaseHpCumulative": 2014270,
      "phaseDefenseCumulative": 10
    },
    {
      "titanLevel": 7,
      "xp": 8700,
      "xpCumulative": 22100,
      "attack": 48437,
      "hp": 571428,
      "defense": 3,
      "maxLevel": 5,
      "attackCumulative": 532419,
      "hpCumulative": 5013182,
      "defenseCumulative": 40,
      "tierPhase": "Green",
      "tierLevel": 6,
      "phaseAndLevel": "Green6",
      "phaseAttack": 27359,
      "phaseHp": 402854,
      "phaseDefense": 2,
      "phaseAttackCumulative": 164154,
      "phaseHpCumulative": 2417124,
      "phaseDefenseCumulative": 12
    },
    {
      "titanLevel": 8,
      "xp": 12600,
      "xpCumulative": 34700,
      "attack": 53285.41473795068,
      "hp": 644941.2446003763,
      "defense": 3,
      "maxLevel": 5,
      "attackCumulative": 585704.4147379507,
      "hpCumulative": 5658123.244600376,
      "defenseCumulative": 43,
      "tierPhase": "Green",
      "tierLevel": 7,
      "phaseAndLevel": "Green7",
      "phaseAttack": 27359,
      "phaseHp": 402854,
      "phaseDefense": 2,
      "phaseAttackCumulative": 191513,
      "phaseHpCumulative": 2819978,
      "phaseDefenseCumulative": 14
    },
    {
      "titanLevel": 9,
      "xp": 17800,
      "xpCumulative": 52500,
      "attack": 58618,
      "hp": 727914,
      "defense": 4,
      "maxLevel": 5,
      "attackCumulative": 644322.4147379507,
      "hpCumulative": 6386037.244600376,
      "defenseCumulative": 47,
      "tierPhase": "Green",
      "tierLevel": 8,
      "phaseAndLevel": "Green8",
      "phaseAttack": 27359,
      "phaseHp": 402854,
      "phaseDefense": 2,
      "phaseAttackCumulative": 218872,
      "phaseHpCumulative": 3222832,
      "phaseDefenseCumulative": 16
    },
    {
      "titanLevel": 10,
      "xp": 24400,
      "xpCumulative": 76900,
      "attack": 64484,
      "hp": 821559,
      "defense": 5,
      "maxLevel": 5,
      "attackCumulative": 708806.4147379507,
      "hpCumulative": 7207596.244600376,
      "defenseCumulative": 52,
      "tierPhase": "Green",
      "tierLevel": 9,
      "phaseAndLevel": "Green9",
      "phaseAttack": 27359,
      "phaseHp": 402854,
      "phaseDefense": 2,
      "phaseAttackCumulative": 246231,
      "phaseHpCumulative": 3625686,
      "phaseDefenseCumulative": 18
    },
    {
      "titanLevel": 11,
      "xp": 33000,
      "xpCumulative": 109900,
      "attack": 65350,
      "hp": 801285,
      "defense": 4,
      "maxLevel": 5,
      "attackCumulative": 774156.4147379507,
      "hpCumulative": 8008881.244600376,
      "defenseCumulative": 56,
      "tierPhase": "Blue",
      "tierLevel": 0,
      "phaseAndLevel": "Blue0",
      "phaseAttack": 27359,
      "phaseHp": 402854,
      "phaseDefense": 2,
      "phaseAttackCumulative": 273590,
      "phaseHpCumulative": 4028540,
      "phaseDefenseCumulative": 20
    },
    {
      "titanLevel": 12,
      "xp": 43800,
      "xpCumulative": 153700,
      "attack": 71375.08419258677,
      "hp": 890365.6914557236,
      "defense": 4,
      "maxLevel": 5,
      "attackCumulative": 845531.4989305374,
      "hpCumulative": 8899246.9360561,
      "defenseCumulative": 60,
      "tierPhase": "Blue",
      "tierLevel": 1,
      "phaseAndLevel": "Blue1",
      "phaseAttack": 41039,
      "phaseHp": 604281,
      "phaseDefense": 2,
      "phaseAttackCumulative": 314629,
      "phaseHpCumulative": 4632821,
      "phaseDefenseCumulative": 22
    },
    {
      "titanLevel": 13,
      "xp": 57400,
      "xpCumulative": 211100,
      "attack": 77956,
      "hp": 989351,
      "defense": 5,
      "maxLevel": 6,
      "attackCumulative": 923487.4989305374,
      "hpCumulative": 9888597.9360561,
      "defenseCumulative": 65,
      "tierPhase": "Blue",
      "tierLevel": 2,
      "phaseAndLevel": "Blue2",
      "phaseAttack": 41039,
      "phaseHp": 604281,
      "phaseDefense": 2,
      "phaseAttackCumulative": 355668,
      "phaseHpCumulative": 5237102,
      "phaseDefenseCumulative": 24
    },
    {
      "titanLevel": 14,
      "xp": 74300,
      "xpCumulative": 285400,
      "attack": 85144,
      "hp": 1099339,
      "defense": 5,
      "maxLevel": 6,
      "attackCumulative": 1008631.4989305374,
      "hpCumulative": 10987936.9360561,
      "defenseCumulative": 70,
      "tierPhase": "Blue",
      "tierLevel": 3,
      "phaseAndLevel": "Blue3",
      "phaseAttack": 41039,
      "phaseHp": 604281,
      "phaseDefense": 2,
      "phaseAttackCumulative": 396707,
      "phaseHpCumulative": 5841383,
      "phaseDefenseCumulative": 26
    },
    {
      "titanLevel": 15,
      "xp": 95100,
      "xpCumulative": 380500,
      "attack": 92944,
      "hp": 1221555,
      "defense": 6,
      "maxLevel": 7,
      "attackCumulative": 1101575.4989305374,
      "hpCumulative": 12209491.9360561,
      "defenseCumulative": 76,
      "tierPhase": "Blue",
      "tierLevel": 4,
      "phaseAndLevel": "Blue4",
      "phaseAttack": 41039,
      "phaseHp": 604281,
      "phaseDefense": 2,
      "phaseAttackCumulative": 437746,
      "phaseHpCumulative": 6445664,
      "phaseDefenseCumulative": 28
    },
    {
      "titanLevel": 16,
      "xp": 115900,
      "xpCumulative": 496400,
      "attack": 92656,
      "hp": 1237343,
      "defense": 6,
      "maxLevel": 7,
      "attackCumulative": 1194231.4989305374,
      "hpCumulative": 13446834.9360561,
      "defenseCumulative": 82,
      "tierPhase": "Blue",
      "tierLevel": 5,
      "phaseAndLevel": "Blue5",
      "phaseAttack": 41039,
      "phaseHp": 604281,
      "phaseDefense": 2,
      "phaseAttackCumulative": 478785,
      "phaseHpCumulative": 7049945,
      "phaseDefenseCumulative": 30
    },
    {
      "titanLevel": 17,
      "xp": 139700,
      "xpCumulative": 636100,
      "attack": 100450,
      "hp": 1362738,
      "defense": 5,
      "maxLevel": 8,
      "attackCumulative": 1294681.4989305374,
      "hpCumulative": 14809572.9360561,
      "defenseCumulative": 87,
      "tierPhase": "Blue",
      "tierLevel": 6,
      "phaseAndLevel": "Blue6",
      "phaseAttack": 41039,
      "phaseHp": 604281,
      "phaseDefense": 2,
      "phaseAttackCumulative": 519824,
      "phaseHpCumulative": 7654226,
      "phaseDefenseCumulative": 32
    },
    {
      "titanLevel": 18,
      "xp": 166800,
      "xpCumulative": 802900,
      "attack": 108898,
      "hp": 1500842,
      "defense": 7,
      "maxLevel": 8,
      "attackCumulative": 1403579.4989305374,
      "hpCumulative": 16310414.9360561,
      "defenseCumulative": 94,
      "tierPhase": "Blue",
      "tierLevel": 7,
      "phaseAndLevel": "Blue7",
      "phaseAttack": 41039,
      "phaseHp": 604281,
      "phaseDefense": 2,
      "phaseAttackCumulative": 560863,
      "phaseHpCumulative": 8258507,
      "phaseDefenseCumulative": 34
    },
    {
      "titanLevel": 19,
      "xp": 197300,
      "xpCumulative": 1000200,
      "attack": 118058,
      "hp": 1652941,
      "defense": 7,
      "maxLevel": 9,
      "attackCumulative": 1521637.4989305374,
      "hpCumulative": 17963355.9360561,
      "defenseCumulative": 101,
      "tierPhase": "Blue",
      "tierLevel": 8,
      "phaseAndLevel": "Blue8",
      "phaseAttack": 41039,
      "phaseHp": 604281,
      "phaseDefense": 2,
      "phaseAttackCumulative": 601902,
      "phaseHpCumulative": 8862788,
      "phaseDefenseCumulative": 36
    },
    {
      "titanLevel": 20,
      "xp": 231400,
      "xpCumulative": 1231600,
      "attack": 127988,
      "hp": 1820455,
      "defense": 7,
      "maxLevel": 9,
      "attackCumulative": 1649625.4989305374,
      "hpCumulative": 19783810.9360561,
      "defenseCumulative": 108,
      "tierPhase": "Blue",
      "tierLevel": 9,
      "phaseAndLevel": "Blue9",
      "phaseAttack": 41039,
      "phaseHp": 604281,
      "phaseDefense": 2,
      "phaseAttackCumulative": 642941,
      "phaseHpCumulative": 9467069,
      "phaseDefenseCumulative": 38
    },
    {
      "titanLevel": 21,
      "xp": 269100,
      "xpCumulative": 1500700,
      "attack": 125344.32399858901,
      "hp": 1843404.82646684,
      "defense": 8,
      "maxLevel": 10,
      "attackCumulative": 1774969.8229291264,
      "hpCumulative": 21627215.76252294,
      "defenseCumulative": 116,
      "tierPhase": "Purple",
      "tierLevel": 0,
      "phaseAndLevel": "Purple0",
      "phaseAttack": 41039,
      "phaseHp": 604281,
      "phaseDefense": 2,
      "phaseAttackCumulative": 683980,
      "phaseHpCumulative": 10071350,
      "phaseDefenseCumulative": 40
    },
    {
      "titanLevel": 22,
      "xp": 310400,
      "xpCumulative": 1811100,
      "attack": 134812,
      "hp": 2015163.3928571427,
      "defense": 8,
      "maxLevel": 11,
      "attackCumulative": 1909781.8229291264,
      "hpCumulative": 23642379.15538008,
      "defenseCumulative": 124,
      "tierPhase": "Purple",
      "tierLevel": 1,
      "phaseAndLevel": "Purple1",
      "phaseAttack": 57454,
      "phaseHp": 845994,
      "phaseDefense": 3,
      "phaseAttackCumulative": 741434,
      "phaseHpCumulative": 10917344,
      "phaseDefenseCumulative": 43
    },
    {
      "titanLevel": 23,
      "xp": 355000,
      "xpCumulative": 2166100,
      "attack": 145054,
      "hp": 2202931.25,
      "defense": 8,
      "maxLevel": 11,
      "attackCumulative": 2054835.8229291264,
      "hpCumulative": 25845310.40538008,
      "defenseCumulative": 132,
      "tierPhase": "Purple",
      "tierLevel": 2,
      "phaseAndLevel": "Purple2",
      "phaseAttack": 57454,
      "phaseHp": 845994,
      "phaseDefense": 3,
      "phaseAttackCumulative": 798888,
      "phaseHpCumulative": 11763338,
      "phaseDefenseCumulative": 46
    },
    {
      "titanLevel": 24,
      "xp": 402900,
      "xpCumulative": 2569000,
      "attack": 156067,
      "hp": 2408194.6428571427,
      "defense": 9,
      "maxLevel": 12,
      "attackCumulative": 2210902.822929126,
      "hpCumulative": 28253505.048237223,
      "defenseCumulative": 141,
      "tierPhase": "Purple",
      "tierLevel": 3,
      "phaseAndLevel": "Purple3",
      "phaseAttack": 57454,
      "phaseHp": 845994,
      "phaseDefense": 3,
      "phaseAttackCumulative": 856342,
      "phaseHpCumulative": 12609332,
      "phaseDefenseCumulative": 49
    },
    {
      "titanLevel": 25,
      "xp": 453300,
      "xpCumulative": 3022300,
      "attack": 167922,
      "hp": 2632583.0357142854,
      "defense": 9,
      "maxLevel": 12,
      "attackCumulative": 2378824.822929126,
      "hpCumulative": 30886088.08395151,
      "defenseCumulative": 150,
      "tierPhase": "Purple",
      "tierLevel": 4,
      "phaseAndLevel": "Purple4",
      "phaseAttack": 57454,
      "phaseHp": 845994,
      "phaseDefense": 3,
      "phaseAttackCumulative": 913796,
      "phaseHpCumulative": 13455326,
      "phaseDefenseCumulative": 52
    },
    {
      "titanLevel": 26,
      "xp": 523800,
      "xpCumulative": 3546100,
      "attack": 162219,
      "hp": 2658358.928571428,
      "defense": 10,
      "maxLevel": 13,
      "attackCumulative": 2541043.822929126,
      "hpCumulative": 33544447.01252294,
      "defenseCumulative": 160,
      "tierPhase": "Purple",
      "tierLevel": 5,
      "phaseAndLevel": "Purple5",
      "phaseAttack": 57454,
      "phaseHp": 845994,
      "phaseDefense": 3,
      "phaseAttackCumulative": 971250,
      "phaseHpCumulative": 14301320,
      "phaseDefenseCumulative": 55
    },
    {
      "titanLevel": 27,
      "xp": 602100,
      "xpCumulative": 4148200,
      "attack": 173281,
      "hp": 2887164,
      "defense": 10,
      "maxLevel": 13,
      "attackCumulative": 2714324.822929126,
      "hpCumulative": 36431611.012522936,
      "defenseCumulative": 170,
      "tierPhase": "Purple",
      "tierLevel": 6,
      "phaseAndLevel": "Purple6",
      "phaseAttack": 57454,
      "phaseHp": 845994,
      "phaseDefense": 3,
      "phaseAttackCumulative": 1028704,
      "phaseHpCumulative": 15147314,
      "phaseDefenseCumulative": 58
    },
    {
      "titanLevel": 28,
      "xp": 688800,
      "xpCumulative": 4837000,
      "attack": 185097,
      "hp": 3135661.607142857,
      "defense": 10,
      "maxLevel": 14,
      "attackCumulative": 2899421.822929126,
      "hpCumulative": 39567272.619665794,
      "defenseCumulative": 180,
      "tierPhase": "Purple",
      "tierLevel": 7,
      "phaseAndLevel": "Purple7",
      "phaseAttack": 57454,
      "phaseHp": 845994,
      "phaseDefense": 3,
      "phaseAttackCumulative": 1086158,
      "phaseHpCumulative": 15993308,
      "phaseDefenseCumulative": 61
    },
    {
      "titanLevel": 29,
      "xp": 784200,
      "xpCumulative": 5621200,
      "attack": 197720,
      "hp": 3405547.321428571,
      "defense": 11,
      "maxLevel": 14,
      "attackCumulative": 3097141.822929126,
      "hpCumulative": 42972819.94109437,
      "defenseCumulative": 191,
      "tierPhase": "Purple",
      "tierLevel": 8,
      "phaseAndLevel": "Purple8",
      "phaseAttack": 57454,
      "phaseHp": 845994,
      "phaseDefense": 3,
      "phaseAttackCumulative": 1143612,
      "phaseHpCumulative": 16839302,
      "phaseDefenseCumulative": 64
    },
    {
      "titanLevel": 30,
      "xp": 888500,
      "xpCumulative": 6509700,
      "attack": 211200,
      "hp": 3698662.1052038115,
      "defense": 12,
      "maxLevel": 15,
      "attackCumulative": 3308341.822929126,
      "hpCumulative": 46671482.04629818,
      "defenseCumulative": 203,
      "tierPhase": "Purple",
      "tierLevel": 9,
      "phaseAndLevel": "Purple9",
      "phaseAttack": 57454,
      "phaseHp": 845994,
      "phaseDefense": 3,
      "phaseAttackCumulative": 1201066,
      "phaseHpCumulative": 17685296,
      "phaseDefenseCumulative": 67
    },
    {
      "titanLevel": 31,
      "xp": 1002100,
      "xpCumulative": 7511800,
      "attack": 243948,
      "hp": 3961266.964285714,
      "defense": 13,
      "maxLevel": 16,
      "attackCumulative": 3552289.822929126,
      "hpCumulative": 50632749.0105839,
      "defenseCumulative": 216,
      "tierPhase": "Gold",
      "tierLevel": 0,
      "phaseAndLevel": "Gold0",
      "phaseAttack": 57454,
      "phaseHp": 845994,
      "phaseDefense": 3,
      "phaseAttackCumulative": 1258520,
      "phaseHpCumulative": 18531290,
      "phaseDefenseCumulative": 70
    },
    {
      "titanLevel": 32,
      "xp": 1124900,
      "xpCumulative": 8636700,
      "attack": 276527,
      "hp": 4242516.964285714,
      "defense": 13,
      "maxLevel": 17,
      "attackCumulative": 3828816.822929126,
      "hpCumulative": 54875265.97486962,
      "defenseCumulative": 229,
      "tierPhase": "Gold",
      "tierLevel": 1,
      "phaseAndLevel": "Gold1",
      "phaseAttack": 75238,
      "phaseHp": 1107849,
      "phaseDefense": 4,
      "phaseAttackCumulative": 1333758,
      "phaseHpCumulative": 19639139,
      "phaseDefenseCumulative": 74
    },
    {
      "titanLevel": 33,
      "xp": 1256800,
      "xpCumulative": 9893500,
      "attack": 308945,
      "hp": 4543735.714285714,
      "defense": 14,
      "maxLevel": 18,
      "attackCumulative": 4137761.822929126,
      "hpCumulative": 59419001.68915533,
      "defenseCumulative": 243,
      "tierPhase": "Gold",
      "tierLevel": 2,
      "phaseAndLevel": "Gold2",
      "phaseAttack": 75238,
      "phaseHp": 1107849,
      "phaseDefense": 4,
      "phaseAttackCumulative": 1408996,
      "phaseHpCumulative": 20746988,
      "phaseDefenseCumulative": 78
    },
    {
      "titanLevel": 34,
      "xp": 1397600,
      "xpCumulative": 11291100,
      "attack": 341200,
      "hp": 4866341.964285714,
      "defense": 15,
      "maxLevel": 19,
      "attackCumulative": 4478961.822929126,
      "hpCumulative": 64285343.65344105,
      "defenseCumulative": 258,
      "tierPhase": "Gold",
      "tierLevel": 3,
      "phaseAndLevel": "Gold3",
      "phaseAttack": 75238,
      "phaseHp": 1107849,
      "phaseDefense": 4,
      "phaseAttackCumulative": 1484234,
      "phaseHpCumulative": 21854837,
      "phaseDefenseCumulative": 82
    },
    {
      "titanLevel": 35,
      "xp": 1546800,
      "xpCumulative": 12837900,
      "attack": 373293,
      "hp": 5211851.785714285,
      "defense": 16,
      "maxLevel": 20,
      "attackCumulative": 4852254.822929126,
      "hpCumulative": 69497195.43915534,
      "defenseCumulative": 274,
      "tierPhase": "Gold",
      "tierLevel": 4,
      "phaseAndLevel": "Gold4",
      "phaseAttack": 75238,
      "phaseHp": 1107849,
      "phaseDefense": 4,
      "phaseAttackCumulative": 1559472,
      "phaseHpCumulative": 22962686,
      "phaseDefenseCumulative": 86
    },
    {
      "titanLevel": 36,
      "xp": 1703500,
      "xpCumulative": 14541400,
      "attack": 405228,
      "hp": 5581892.857142856,
      "defense": 17,
      "maxLevel": 20,
      "attackCumulative": 5257482.822929126,
      "hpCumulative": 75079088.29629819,
      "defenseCumulative": 291,
      "tierPhase": "Gold",
      "tierLevel": 5,
      "phaseAndLevel": "Gold5",
      "phaseAttack": 75238,
      "phaseHp": 1107849,
      "phaseDefense": 4,
      "phaseAttackCumulative": 1634710,
      "phaseHpCumulative": 24070535,
      "phaseDefenseCumulative": 90
    },
    {
      "titanLevel": 37,
      "xp": 1866500,
      "xpCumulative": 16407900,
      "attack": 437005,
      "hp": 5978206.81586253,
      "defense": 18,
      "maxLevel": 20,
      "attackCumulative": 5694487.822929126,
      "hpCumulative": 81057295.11216073,
      "defenseCumulative": 309,
      "tierPhase": "Gold",
      "tierLevel": 6,
      "phaseAndLevel": "Gold6",
      "phaseAttack": 75238,
      "phaseHp": 1107849,
      "phaseDefense": 4,
      "phaseAttackCumulative": 1709948,
      "phaseHpCumulative": 25178384,
      "phaseDefenseCumulative": 94
    },
    {
      "titanLevel": 38,
      "xp": 2034400,
      "xpCumulative": 18442300,
      "attack": 468617,
      "hp": 6402659.821428571,
      "defense": 19,
      "maxLevel": 20,
      "attackCumulative": 6163104.822929126,
      "hpCumulative": 87459954.9335893,
      "defenseCumulative": 328,
      "tierPhase": "Gold",
      "tierLevel": 7,
      "phaseAndLevel": "Gold7",
      "phaseAttack": 75238,
      "phaseHp": 1107849,
      "phaseDefense": 4,
      "phaseAttackCumulative": 1785186,
      "phaseHpCumulative": 26286233,
      "phaseDefenseCumulative": 98
    },
    {
      "titanLevel": 39,
      "xp": 2205000,
      "xpCumulative": 20647300,
      "attack": 500073,
      "hp": 6857249.107142856,
      "defense": 20,
      "maxLevel": 20,
      "attackCumulative": 6663177.822929126,
      "hpCumulative": 94317204.04073215,
      "defenseCumulative": 348,
      "tierPhase": "Gold",
      "tierLevel": 8,
      "phaseAndLevel": "Gold8",
      "phaseAttack": 75238,
      "phaseHp": 1107849,
      "phaseDefense": 4,
      "phaseAttackCumulative": 1860424,
      "phaseHpCumulative": 27394082,
      "phaseDefenseCumulative": 102
    },
    {
      "titanLevel": 40,
      "xp": 2375800,
      "xpCumulative": 23023100,
      "attack": 531373.1481481481,
      "hp": 7344113.392857142,
      "defense": 21,
      "maxLevel": 20,
      "attackCumulative": 7194550.9710772745,
      "hpCumulative": 101661317.43358928,
      "defenseCumulative": 369,
      "tierPhase": "Gold",
      "tierLevel": 9,
      "phaseAndLevel": "Gold9",
      "phaseAttack": 75238,
      "phaseHp": 1107849,
      "phaseDefense": 4,
      "phaseAttackCumulative": 1935662,
      "phaseHpCumulative": 28501931,
      "phaseDefenseCumulative": 106
    },
    {
      "titanLevel": 41,
      "xp": 2755900,
      "xpCumulative": 25779000,
      "attack": 308196.2963,
      "hp": 3672057.1428571427,
      "defense": 11,
      "maxLevel": 20,
      "attackCumulative": 7527402.9710772745,
      "hpCumulative": 105333374.57644643,
      "defenseCumulative": 380,
      "tierPhase": "Gold",
      "tierLevel": 10,
      "phaseAndLevel": "Gold10",
      "phaseAttack": 75238,
      "phaseHp": 1107849,
      "phaseDefense": 4,
      "phaseAttackCumulative": 2010900,
      "phaseHpCumulative": 29609780,
      "phaseDefenseCumulative": 110
    },
    {
      "titanLevel": 42,
      "xp": 3114200,
      "xpCumulative": 28893200,
      "attack": 308197.2222,
      "hp": 3672056.2499999995,
      "defense": 10,
      "maxLevel": 20,
      "attackCumulative": 7860255.9710772745,
      "hpCumulative": 109005430.82644643,
      "defenseCumulative": 390
    },
    {
      "titanLevel": 43,
      "xp": 3425600,
      "xpCumulative": 32318800,
      "attack": 308197.2222,
      "hp": 3672056.2499999995,
      "defense": 10,
      "maxLevel": 20,
      "attackCumulative": 8193108.9710772745,
      "hpCumulative": 112677487.07644643,
      "defenseCumulative": 400
    },
    {
      "titanLevel": 44,
      "xp": 3665400,
      "xpCumulative": 35984200,
      "attack": 308197.2222,
      "hp": 3672057.1428571427,
      "defense": 11,
      "maxLevel": 20,
      "attackCumulative": 8525960.971077275,
      "hpCumulative": 116349544.21930358,
      "defenseCumulative": 411
    },
    {
      "titanLevel": 45,
      "xp": 3812000,
      "xpCumulative": 39796200,
      "attack": 308197.2222,
      "hp": 3672057.1428571427,
      "defense": 10,
      "maxLevel": 20,
      "attackCumulative": 8858812.971077275,
      "hpCumulative": 120021601.36216073,
      "defenseCumulative": 421
    }
  ],
  "evolution": {
    "phaseField": "tierPhase",
    "evolutionLevelField": "tierLevel",
    "timeline": [
      {
        "titanLevel": 1,
        "phase": "Green",
        "evolutionLevel": 0,
        "phaseAndLevel": "Green0"
      },
      {
        "titanLevel": 2,
        "phase": "Green",
        "evolutionLevel": 1,
        "phaseAndLevel": "Green1"
      },
      {
        "titanLevel": 3,
        "phase": "Green",
        "evolutionLevel": 2,
        "phaseAndLevel": "Green2"
      },
      {
        "titanLevel": 4,
        "phase": "Green",
        "evolutionLevel": 3,
        "phaseAndLevel": "Green3"
      },
      {
        "titanLevel": 5,
        "phase": "Green",
        "evolutionLevel": 4,
        "phaseAndLevel": "Green4"
      },
      {
        "titanLevel": 6,
        "phase": "Green",
        "evolutionLevel": 5,
        "phaseAndLevel": "Green5"
      },
      {
        "titanLevel": 7,
        "phase": "Green",
        "evolutionLevel": 6,
        "phaseAndLevel": "Green6"
      },
      {
        "titanLevel": 8,
        "phase": "Green",
        "evolutionLevel": 7,
        "phaseAndLevel": "Green7"
      },
      {
        "titanLevel": 9,
        "phase": "Green",
        "evolutionLevel": 8,
        "phaseAndLevel": "Green8"
      },
      {
        "titanLevel": 10,
        "phase": "Green",
        "evolutionLevel": 9,
        "phaseAndLevel": "Green9"
      },
      {
        "titanLevel": 11,
        "phase": "Blue",
        "evolutionLevel": 0,
        "phaseAndLevel": "Blue0"
      },
      {
        "titanLevel": 12,
        "phase": "Blue",
        "evolutionLevel": 1,
        "phaseAndLevel": "Blue1"
      },
      {
        "titanLevel": 13,
        "phase": "Blue",
        "evolutionLevel": 2,
        "phaseAndLevel": "Blue2"
      },
      {
        "titanLevel": 14,
        "phase": "Blue",
        "evolutionLevel": 3,
        "phaseAndLevel": "Blue3"
      },
      {
        "titanLevel": 15,
        "phase": "Blue",
        "evolutionLevel": 4,
        "phaseAndLevel": "Blue4"
      },
      {
        "titanLevel": 16,
        "phase": "Blue",
        "evolutionLevel": 5,
        "phaseAndLevel": "Blue5"
      },
      {
        "titanLevel": 17,
        "phase": "Blue",
        "evolutionLevel": 6,
        "phaseAndLevel": "Blue6"
      },
      {
        "titanLevel": 18,
        "phase": "Blue",
        "evolutionLevel": 7,
        "phaseAndLevel": "Blue7"
      },
      {
        "titanLevel": 19,
        "phase": "Blue",
        "evolutionLevel": 8,
        "phaseAndLevel": "Blue8"
      },
      {
        "titanLevel": 20,
        "phase": "Blue",
        "evolutionLevel": 9,
        "phaseAndLevel": "Blue9"
      },
      {
        "titanLevel": 21,
        "phase": "Purple",
        "evolutionLevel": 0,
        "phaseAndLevel": "Purple0"
      },
      {
        "titanLevel": 22,
        "phase": "Purple",
        "evolutionLevel": 1,
        "phaseAndLevel": "Purple1"
      },
      {
        "titanLevel": 23,
        "phase": "Purple",
        "evolutionLevel": 2,
        "phaseAndLevel": "Purple2"
      },
      {
        "titanLevel": 24,
        "phase": "Purple",
        "evolutionLevel": 3,
        "phaseAndLevel": "Purple3"
      },
      {
        "titanLevel": 25,
        "phase": "Purple",
        "evolutionLevel": 4,
        "phaseAndLevel": "Purple4"
      },
      {
        "titanLevel": 26,
        "phase": "Purple",
        "evolutionLevel": 5,
        "phaseAndLevel": "Purple5"
      },
      {
        "titanLevel": 27,
        "phase": "Purple",
        "evolutionLevel": 6,
        "phaseAndLevel": "Purple6"
      },
      {
        "titanLevel": 28,
        "phase": "Purple",
        "evolutionLevel": 7,
        "phaseAndLevel": "Purple7"
      },
      {
        "titanLevel": 29,
        "phase": "Purple",
        "evolutionLevel": 8,
        "phaseAndLevel": "Purple8"
      },
      {
        "titanLevel": 30,
        "phase": "Purple",
        "evolutionLevel": 9,
        "phaseAndLevel": "Purple9"
      },
      {
        "titanLevel": 31,
        "phase": "Gold",
        "evolutionLevel": 0,
        "phaseAndLevel": "Gold0"
      },
      {
        "titanLevel": 32,
        "phase": "Gold",
        "evolutionLevel": 1,
        "phaseAndLevel": "Gold1"
      },
      {
        "titanLevel": 33,
        "phase": "Gold",
        "evolutionLevel": 2,
        "phaseAndLevel": "Gold2"
      },
      {
        "titanLevel": 34,
        "phase": "Gold",
        "evolutionLevel": 3,
        "phaseAndLevel": "Gold3"
      },
      {
        "titanLevel": 35,
        "phase": "Gold",
        "evolutionLevel": 4,
        "phaseAndLevel": "Gold4"
      },
      {
        "titanLevel": 36,
        "phase": "Gold",
        "evolutionLevel": 5,
        "phaseAndLevel": "Gold5"
      },
      {
        "titanLevel": 37,
        "phase": "Gold",
        "evolutionLevel": 6,
        "phaseAndLevel": "Gold6"
      },
      {
        "titanLevel": 38,
        "phase": "Gold",
        "evolutionLevel": 7,
        "phaseAndLevel": "Gold7"
      },
      {
        "titanLevel": 39,
        "phase": "Gold",
        "evolutionLevel": 8,
        "phaseAndLevel": "Gold8"
      },
      {
        "titanLevel": 40,
        "phase": "Gold",
        "evolutionLevel": 9,
        "phaseAndLevel": "Gold9"
      },
      {
        "titanLevel": 41,
        "phase": "Gold",
        "evolutionLevel": 10,
        "phaseAndLevel": "Gold10"
      }
    ],
    "phases": [
      {
        "phase": "Green",
        "minTitanLevel": 1,
        "maxTitanLevel": 10,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      },
      {
        "phase": "Blue",
        "minTitanLevel": 11,
        "maxTitanLevel": 20,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      },
      {
        "phase": "Purple",
        "minTitanLevel": 21,
        "maxTitanLevel": 30,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      },
      {
        "phase": "Gold",
        "minTitanLevel": 31,
        "maxTitanLevel": 41,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10
        ]
      }
    ]
  }
};
